import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { Component, ElementRef, ViewChild, AfterViewInit } from "@angular/core";
import { AgEditorComponent, AgRendererComponent } from "@bfx/ag-grid-angular";

@Component({
  selector: "order-intent-editor",
  templateUrl: "./html/IntentEditor.html",
  standalone: false,
})
export class IntentEditor implements AgEditorComponent, AgRendererComponent {
  public params: any;
  public isBuy: boolean = false;
  public omitRow: boolean = false;
  public title: string = null;

  @ViewChild("button", { static: true })
  public buttonElement: ElementRef;

  getValue(): any {
    if (this.omitRow) {
      return;
    }

    let value: CubiqTS.OrderIntent = this.isBuy
      ? CubiqTS.OrderIntent.BUY
      : CubiqTS.OrderIntent.SELL;
    this.title = this.isBuy ? "Buy" : "Sell";

    if (this.params.context != null && this.params.context.setEditedValue != null) {
      this.params.context.setEditedValue(value, this.params);
    }
    return value;
  }

  // called on init
  agInit(params: any): void {
    this.params = params;
    this.omitRow = params.value === "omitRow";
    this.isBuy = params.value == "Buy" || params.value === true;
    this.title = params.value;
  }

  public get editingEnabled(): boolean {
    if (this.params.context && this.params.context.isCellEditingEnabled) {
      return this.params.context.isCellEditingEnabled(this.params);
    }
    return false;
  }

  afterGuiAttached(): void {
    this.buttonElement?.nativeElement?.focus();
  }

  public toggleValue(): void {
    if (this.editingEnabled) {
      this.isBuy = !this.isBuy;
      this.getValue();
    }
  }

  isCancelBeforeStart?(): boolean {
    return !this.editingEnabled;
  }

  isCancelAfterEnd?(): boolean {
    return !this.editingEnabled;
  }

  refresh(params: any): boolean {
    this.agInit(params);
    return true;
  }
}
